// extracted by mini-css-extract-plugin
export var container = "video-module--container--5e68c";
export var transformContainer = "video-module--transformContainer--a1ab4";